// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'

import { AuthenticationServicePlugin } from './services/AuthenticationService'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/custom.css'
import('./assets/' + process.env.VUE_APP_CUSTOMER + '/Customer.css')

Vue.use(AuthenticationServicePlugin)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.use({
  install(Vue) {
    Vue.prototype.$api = axios.create({
      baseURL: process.env.VUE_APP_ROOTAPI
    })

    // Request interceptor for API calls
    Vue.prototype.$api.interceptors.request.use(
      // TODO Check expires At date if its expired login again with refreshtoken let op wellicht gaat dit dan de login blocken
      // If there is no refreshtoken use router to push to login
      async config => {
        config.headers = {
          'Authorization': `Bearer ` + Vue.prototype.$authService.getAccessToken()
        }
        return config
      },
      error => {
        Promise.reject(error)
      })

    Vue.prototype.$api.interceptors.response.use((response) => {
      return response
    },
      async function (error) {
        const originalRequest = error.config
        if (error.response.status === 401 && !originalRequest._retry) {
          if (originalRequest.url === 'login/logout') {
            return
          }

          originalRequest._retry = true

          if (Vue.prototype.$authService.canRefreshAccessToken()) {
            if (await Vue.prototype.$authService.refreshAccessToken() === true) {
              return Vue.prototype.$api(originalRequest)
            } else {
              router.push({ name: 'login' })
              return
            }
          } else {
            router.push({ name: 'login' })
            return
          }
        }

        return Promise.reject(error)
      })
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js